import { clsx } from "../../utils/clsx";
import * as styles from "./BrandLogo.css";

type BrandLogoProps = {
  inverse?: boolean;
  compact?: boolean;
};

export function BrandLogo({ inverse = false, compact = false }: BrandLogoProps) {
  return (
    <span
      className={clsx(styles.logo, inverse && styles.inverse, compact && styles.compact)}
      aria-label="Ayro Technologies"
    >
      <svg
        className={styles.mark}
        viewBox="0 0 96 96"
        role="img"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M30 31a22 22 0 0 0 0 34"
          fill="none"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M74 31a22 22 0 0 1 0 34"
          fill="none"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path d="M39 18h7v60h-7Z" fill="currentColor" />
        <path d="M49 30h7v48h-7Z" fill="currentColor" />
        <path d="M59 44h7v34h-7Z" fill="currentColor" />
      </svg>
      <span className={styles.text}>
        <span>Ayro</span>
        <span>Technologies</span>
      </span>
    </span>
  );
}
